import ConfirmationModal from 'components/common/ConfirmationMessage';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InterpreterDashboardSelector } from 'slices/interpreter/dashboardSlice';
import SelectInterpreterModal from '../SelectInterpreterModal';
import { setVendorActionAssign, acceptVendorAppointment } from 'slices/actionButtonSlice';
import { declineAppointments } from 'slices/actionButtonSlice';

import CancelModal from 'components/appointment/CancelModal';
import { fetchVendorDashboardAppointments, VendorDashboardSelector } from 'slices/vendor/dashboardSlice';
import { convertTimeToUTCNew } from 'helpers/convertTimeToUTC';

const ListTable = ({ data, paginationParams, filterKey }) => {
    const dispatch = useDispatch();
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [selectAppt, setSelectAppt] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'id',
        sortDirection: 'desc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const [modalType, setModalType] = React.useState('assign');

    const { last_page: totalPages, total, current_page, per_page: pageLength } = useSelector(VendorDashboardSelector);

    // Reset search when dashboard filters change (filterKey increments on Search/Reset/Legend)
    React.useEffect(() => {
        setSearchTerm("");
    }, [filterKey]);


    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            hideConfirmDialog()
            dispatch(fetchVendorDashboardAppointments(currentPage, { ...paginationParams, ...sortConfig, search: searchTerm, pageLength: pageLength }))
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }
    const handleDeclineConfirm = () => {
        dispatch(declineAppointments({ id: declineModal?.item?.id, assignee: 'vendor' }, submitCallback))
    }
    const handleCancel = (data) => {
        setSelectAppt(data);
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    const handleAssignInterpreter = (data) => {
        setSelectAppt(data);
        setModalType('assign');
        setAssignInterpreter(true);
    };
    const handleAccept = (data) => {
        setSelectAppt(data);
        setModalType('accept');
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };


    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseAssignInterpreter();
                handleCloseCancel();

                dispatch(fetchVendorDashboardAppointments(currentPage, { ...paginationParams, ...sortConfig, search: searchTerm, pageLength: pageLength }))
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
            }
            else {
                toast.error(message,
                    { className: "errorToast", }
                );
                setLoading(false)
            }
        }
        if (end_point === 'accept') {
            dispatch(
                acceptVendorAppointment(
                    selectAppt.id,
                    data,
                    submitCallback
                )
            )
        } else {
            dispatch(
                setVendorActionAssign(
                    selectAppt.id,
                    data,
                    end_point,
                    submitCallback
                )
            )
        }
    }


    //#region TABLE HEAD 
    const renderTableHeader = () => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchVendorDashboardAppointments(currentPage, { ...paginationParams, sortBy: sortBy, sortDirection: dir, search: searchTerm, pageLength: pageLength }))
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Date"
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                {/* <th>
                    <TableHeaderItem
                        title="Facility"
                        sortBy="facility_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th> */}
                <th>
                    <TableHeaderItem
                        title="Department"
                        sortBy="department_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="IMS #"
                        sortBy="ims_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="interpreter_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className='col-2'>
                    Actions
                </th>
            </tr>
        )
    };
    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data && data?.length > 0 ? data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAssign={handleAssignInterpreter} handleAccept={handleAccept} handleDeclineShow={handleDeclineShow} handleCancel={handleCancel} handleAcceptButton={handleAcceptButton} current_page={current_page} pageLength={pageLength} />
            )) : <tr><td colSpan={20} className="text-center">No results found</td></tr>
        )
    }, [selectedItems, data]);


    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        setActionAccept({
            show: true,
            item: { id },
        });
    }, [])

    const handleCloseActionButton = React.useCallback((id) => {
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])

    const handleDeclineShow = React.useCallback((id) => {
        setDeclineModal({
            show: true,
            item: { id },
        });
    }, [])

    console.log("ttototaltalotal", total)

    return (
        <div className='mt-4'>
            <ListLayout
                heading={`dasboard appointments`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchVendorDashboardAppointments}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
                noOfItems={total}
                paginationParams={paginationParams}
                apiCurrentPage={current_page}
            >
                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}
            </ListLayout>

            <SelectInterpreterModal
                isVendorForm={true}
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={selectAppt.id}
                item={selectAppt}
                loader={loading}
                modalType={modalType}
            />


            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={selectAppt.id}
                item={selectAppt}
                loader={loading}
            />
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, current_page, pageLength, handleAssign, handleAccept, handleDeclineShow, handleCancel
}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);


    const getBackgroundStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c9933' };
        } else if (status === 'open') {
            return { background: '#ffb82a33' };
        } else if (status === 'dnc') {
            return { background: '#3176a033' };
        } else if (status === 'cnc') {
            return { background: '#9623e033' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c33' };
        } else if (status === 'cancelled') {
            return { background: '#e33a3133' };
        } else if (status === 'vendor_declined') {
            return { background: '#ff000033' }
        } else if (status === 'declined') {
            return { background: '#ff000033' }
        } else if (status === 'pending') {
            return { background: '#3176a033' }
        }
    };
    const getEyeStyle = (status) => {
        if (status === 'assigned') {
            return { background: '#785c99' };
        } else if (status === 'open') {
            return { background: '#ffb82a' };
        } else if (status === 'dnc') {
            return { background: '#3176a0' };
        } else if (status === 'cnc') {
            return { background: '#9623e0' };
        } else if (status === 'completed') {
            return { background: '#1c2b2c' };
        } else if (status === 'cancelled') {
            return { background: '#e33a31' };
        } else if (status === 'vendor_declined') {
            return { background: '#b51a12' }
        } else if (status === 'declined') {
            return { background: '#b51a12' }
        } else if (status === 'pending') {
            return { background: '#3176a0' }
        }
    };
    { console.log("ititemitemitemem", item) }
    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(item?.status)}>
                <div className='eye_area' style={getEyeStyle(item?.status)}>
                    <Link to={`/vendor/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appid || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)} className='text-transform-capitalize '>
                {item?.status ? item.status.replaceAll('_', ' ') : 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {convertTimeToUTCNew(item?.datetime) || 'N/A'}
            </td>
            {/* <td style={getBackgroundStyle(item?.status)}>
                {item?.appointment_details?.facility?.name || 'N/A'}
            </td> */}
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appointment_details?.department?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.language?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.ims_id || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.interpreter?.user?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                <div className='row_check'>
                    {item?.status == 'open' &&
                        <button type='button' className='main_button green' onClick={() => { handleAccept(item) }}>Accept</button>
                    }
                    {(item?.status == "pending" || item?.status == "assigned") &&
                        <button type='button' className='main_button' onClick={() => { handleAssign(item) }}>{item?.interpreter ? 'Reassign' : 'Assign'}</button>
                    }
                    {(item?.status == "pending" || item?.status == "assigned") &&
                        <button type='button' className='table_delete' onClick={() => { handleCancel(item) }}>Cancel</button>
                    }
                </div>
            </td>

        </tr>
    )
})
export default ListTable